import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import CONSTANTS from '../../../constants';
import { pushEventToGTM } from '../../../helpers/trackerManager';

import {
	Link,
} from 'react-router-dom';
import { CurrentStepSetAction } from '../../../actions/action';
import { slugify } from '../../../helpers/functions'
import SummarySectionBlock from "../summarySectionBlock";
import InfosMessage from "../infosMessage";
import Icon from '../../buttons/Icon';
import EditButton from '../../buttons/EditButton';

const mapStateToProps = state => state;
const mapDispatchToProps = { CurrentStepSetAction };

class DealerSummary extends PureComponent {
	_isMounted = false;
	static defaultProps = {
		Title: "",
		isWithPrice: false,
	};

	constructor(props) {
		super(props);
		this.state = {
			pageLoaded: false,
			showNextEditButtonDealer: false,
			showNextEditButtonDate: false,
		};

	}

	render() {
		const { dealer, booking, isEditMode } = this.props.store;
		const iconLink = (CONSTANTS.SITE_INFO.BRAND_CODE == "P" ? "http://rendezvousenligne.peugeot.fr/v2-assets/static/media/ap-mini-pin.png" : (CONSTANTS.SITE_INFO.BRAND_CODE == "C" ? "https://rendezvousenligne.citroen.fr/v2-assets/static/media/pin-ac-hover.svg" : (CONSTANTS.SITE_INFO.BRAND_CODE == "D" ? "https://rendezvousenligne.dsautomobiles.fr/v2-assets/static/media/ds-mini-pin.png" : "https://rendezvousenligne.citroen.fr/v2-assets/static/media/ac-mini-pin.png")));
		return (
			<SummarySectionBlock
				fold={true}
				opened={true}
				title={CONSTANTS.LABELS.summary_appointment}>
				<div className="dealerInfos-summary-block">
					<h3 tabIndex="0" className="block-title">{dealer.name}</h3>
					<p className="info-block">
						<span tabIndex="0" className="info-block__title">{CONSTANTS.LABELS.summary_appointment_address}</span>
						<Icon Name="location-map" />
						<span tabIndex="0" className="info-block__content">
							{`${dealer.adress} \n ${dealer.zip} ${dealer.city} `}
						</span>
					</p>
					{!this.state.showNextEditButtonDealer &&
						this.props.isWithPrice &&
						!isEditMode &&
						window.isMobile() === 'desktop' &&
						<EditButton
							onClick={(e) => {
								pushEventToGTM({
									pageName: 'summary',
									eventAction: 'Redirection::Internal::Modify',
									eventLabel: 'summary_modify_dealer'
								});

								this.setState({ showNextEditButtonDealer: true });
							}} />
					}


					{!this.state.showNextEditButtonDealer &&
						!this.props.isWithPrice &&
						!isEditMode &&
						window.isMobile() === 'desktop' &&
						<Link to={CONSTANTS.SITE_ROUTS.HOMEPAGE}
							onClick={() => {
								pushEventToGTM({
									pageName: 'summary',
									eventAction: 'Redirection::Internal::Modify',
									eventLabel: 'summary_modify_dealer'
								});
							}}>
							<EditButton span={true} />
						</Link>

					}

					{this.state.showNextEditButtonDealer &&
						window.isMobile() === 'desktop' &&

						<Link to={CONSTANTS.SITE_ROUTS.HOMEPAGE} >
							<EditButton Title={CONSTANTS.LABELS.summary_warning1_continue} span={true} />
						</Link>
					}

					{this.state.showNextEditButtonDealer &&
						this.props.isWithPrice &&
						window.isMobile() === 'desktop' && <InfosMessage>
							{CONSTANTS.LABELS.summary_warning_alert_dealer}
						</InfosMessage>}

				</div>


				{window.isMobile() === 'desktop' && dealer.position && <div className="dealerInfos-map">
					<img className="dealer-map"
						src={`https://maps.googleapis.com/maps/api/staticmap?zoom=13&size=${(window.innerWidth < 800 ? (window.innerWidth - 60) : 170)}x170&maptype=roadmap&markers=icon:${iconLink}|${dealer.position.lat},${dealer.position.lng}&key=${CONSTANTS.SITE_INFO.GOOGLE_MAP_API_KEY}`}
					/>
					<a rel="noopener noreferrer" href={`https://www.google.com/maps/dir//${dealer.position.lat},${dealer.position.lng}/@${dealer.position.lat},${dealer.position.lng},13z`}
						className="linkto"
						target="_blank"
						onClick={() => {
							pushEventToGTM({
								pageName: 'summary',
								eventAction: 'Redirection::External::Map',
								eventLabel: CONSTANTS.LABELS.summary_appointment_togooglemap
							});
						}}
					>
						<span>{CONSTANTS.LABELS.summary_appointment_togooglemap}</span>
						<Icon Name="arrowNav" />
					</a>
				</div>}
				<div className="dealerInfos-date">
					<div className="date-info">
						<p className="info-block">
							<span tabIndex="0" className="info-block__title">{CONSTANTS.LABELS.summary_appointment_date}</span>
							<Icon Name="calendar" />
							<span tabIndex="0" className="info-block__content">{booking.date}</span>
						</p>
					</div>
					<div className="hour-info">
						<p className="info-block">
							<span tabIndex="0" className="info-block__title">{CONSTANTS.LABELS.summary_appointment_hour}</span>
							<Icon Name="clock" />
							<span tabIndex="0" className="info-block__content">{booking.hour}</span>
						</p>
					</div>
					{/* Start dealer Position on Map Image & link */}
					{window.isMobile() != 'desktop' && dealer.position && <div className="dealerInfos-map">
						<img className="dealer-map"
							src={`https://maps.googleapis.com/maps/api/staticmap?zoom=13&size=${(window.innerWidth < 800 ? (window.innerWidth - 60) : 170)}x170&maptype=roadmap&markers=icon:${iconLink}|${dealer.position.lat},${dealer.position.lng}&key=${CONSTANTS.SITE_INFO.GOOGLE_MAP_API_KEY}`} />
						<a rel="noopener noreferrer" href={`https://www.google.com/maps/dir//${dealer.position.lat},${dealer.position.lng}/@${dealer.position.lat},${dealer.position.lng},13z`} className="linkto" target="_blank">
							<span>{CONSTANTS.LABELS.summary_appointment_togooglemap}</span>
							<Icon Name="arrowNav" />
						</a>
					</div>}
					{/* END dealer Position on Map Image & link */}

					{/* Start Edit button for Desktop ( change Date) */}
					{!this.state.showNextEditButtonDate &&
						this.props.isWithPrice &&
						!isEditMode &&
						window.isMobile() === 'desktop' &&
						<EditButton onClick={(e) => {
							pushEventToGTM({
								pageName: 'summary',
								eventAction: 'Redirection::Internal::Modify',
								eventLabel: 'summary_modify_timeslot'
							});
							this.setState({ showNextEditButtonDate: true });
						}} />
					}
					{!this.state.showNextEditButtonDate &&
						this.props.isWithPrice &&
						isEditMode && !this.props.expiredDate &&
						window.isMobile() === 'desktop' &&
						<EditButton onClick={(e) => {
							pushEventToGTM({
								pageName: 'summary',
								eventAction: 'Redirection::Internal::Modify',
								eventLabel: 'summary_modify_timeslot'
							});
							this.setState({ showNextEditButtonDate: true });
						}} />
					}

					{!this.state.showNextEditButtonDate &&
						!this.props.isWithPrice &&
						dealer.city &&
						!isEditMode &&
						window.isMobile() === 'desktop' &&
						<Link to={`${CONSTANTS.SITE_ROUTS.SOLODEALERPAGE}${slugify(dealer.city) + '/' + slugify(dealer.name) + '/' + dealer.geoID}`}
							onClick={(e) => {
								pushEventToGTM({
									pageName: 'summary',
									eventAction: 'Redirection::Internal::Modify',
									eventLabel: 'summary_modify_timeslot'
								});
							}}>
							<EditButton span={true} />
						</Link>}
					{!this.state.showNextEditButtonDate &&
						!this.props.isWithPrice &&
						dealer.city &&
						isEditMode && !this.props.expiredDate &&
						window.isMobile() === 'desktop' &&
						<Link to={`${CONSTANTS.SITE_ROUTS.SOLODEALERPAGE}${slugify(dealer.city) + '/' + slugify(dealer.name) + '/' + dealer.geoID}`}
							onClick={(e) => {
								pushEventToGTM({
									pageName: 'summary',
									eventAction: 'Redirection::Internal::Modify',
									eventLabel: 'summary_modify_timeslot'
								});
							}}>
							<EditButton span={true} />
						</Link>}
					{/* END Edit button for Desktop ( change Date) */}

					{/* Start Edit button for mobile */}
					{!this.state.showNextEditButtonDealer &&
						this.props.isWithPrice &&
						!this.props.expiredDate &&
						window.isMobile() !== 'desktop' &&
						<EditButton onClick={(e) => {
							pushEventToGTM({
								pageName: 'summary',
								eventAction: 'Redirection::Internal::Modify',
								eventLabel: 'summary_modify_dealer'
							});
							this.setState({ showNextEditButtonDealer: true })
						}
						} />
					}

					{!this.state.showNextEditButtonDealer &&
						!this.props.isWithPrice && !this.props.expiredDate &&
						window.isMobile() !== 'desktop' &&
						<Link to={`${CONSTANTS.SITE_ROUTS.SOLODEALERPAGE}${slugify(dealer.city) + '/' + slugify(dealer.name) + '/' + dealer.geoID}`}
							onClick={() => {
								pushEventToGTM({
									pageName: 'summary',
									eventAction: 'Redirection::Internal::Modify',
									eventLabel: 'summary_modify_dealer'
								});
							}} >
							<EditButton span={true} />
						</Link>}

					{this.state.showNextEditButtonDealer &&
						window.isMobile() !== 'desktop' &&
						<Link to={`${CONSTANTS.SITE_ROUTS.SOLODEALERPAGE}${slugify(dealer.city) + '/' + slugify(dealer.name) + '/' + dealer.geoID}`}
							onClick={() => {
								pushEventToGTM({
									pageName: 'summary',
									eventAction: 'Redirection::Internal::Modify',
									eventLabel: 'summary_modify_dealer'
								});
							}} >
							<EditButton Title={CONSTANTS.LABELS.summary_warning1_continue} span={true} />
						</Link>}

					{this.state.showNextEditButtonDealer &&
						this.props.isWithPrice &&
						window.isMobile() !== 'desktop' && <InfosMessage>
							{CONSTANTS.LABELS.summary_warning_alert_dealer}
						</InfosMessage>}
					{/* END Edit button for mobile */}

					{/* Start Edit button for Desktop (Edit Timing) */}
					{this.state.showNextEditButtonDate &&
						<Link to={`${CONSTANTS.SITE_ROUTS.SOLODEALERPAGE}${slugify(dealer.city) + '/' + slugify(dealer.name) + '/' + dealer.geoID}`}>
							<EditButton Title={CONSTANTS.LABELS.summary_warning1_continue} span={true} />
						</Link>}
					{this.state.showNextEditButtonDate &&
						this.props.isWithPrice && <InfosMessage>
							{CONSTANTS.LABELS.summary_warning_alert_slot}
						</InfosMessage>}
					{/* END  Edit button for Desktop (Edit Timing) */}
				</div>
			</SummarySectionBlock>

		)
	}

}


export default connect(mapStateToProps, mapDispatchToProps)(DealerSummary);
